module.exports = __webpack_public_path__ + "media/18-1.39a9c446.mp4";